import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="py-14 md:py-16 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 group mb-4 whitespace-nowrap">
              <span className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center text-secondary-500 font-heading font-bold text-sm">
                {siteInfo.logo}
              </span>
              <span className="font-heading font-semibold text-base text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed max-w-xs">
              {siteInfo.tagline}——为青少年、家长和教师提供科学性教育视频资源，助力每一个孩子健康成长。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/puberty" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                青春期知识
              </Link>
              <Link to="/category/self-protection" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                自我保护
              </Link>
              <Link to="/category/mental-health" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                心理健康
              </Link>
              <Link to="/category/family-education" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                家庭教育
              </Link>
              <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              联系我们
            </h4>
            <div className="space-y-2.5 text-sm text-background-50/70">
              <p className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-background-50/50" />
                <span>{siteInfo.email}</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-background-50/50" />
                <span>{siteInfo.phone}</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-background-50/50" />
                <span>{siteInfo.address}</span>
              </p>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            &copy; {currentYear} {siteInfo.name} 版权所有
          </p>
          <p className="text-xs text-background-50/40">
            京ICP备2024000000号-1
          </p>
        </div>
      </div>
    </footer>
  );
}